import {authAxios} from "../api/axiosClient";
import Cookies from 'universal-cookie';
import {listMyCalendarURL, MyDetailCalendarURL, listUserURL, listRoleURL, listGroupRoleURL, userEditURL,
    listPhuongThucCCURL, listLoaiNVURL, listLoaiUserURL, listChucVuURL, handUserURL, updateRoleUserURL, listTotalTimeURL, resetPassUrl, checkUserHomeUrl
} from "../constants";

export const usersApi = {
    getAll: (params) => {
        const url = '/api/users';
        return authAxios().get(url,{params});
    },
}

export const listMyCalendarApi =(params={})=> {
    const url = listMyCalendarURL;
    return authAxios().get(url,{params});
}

export const MyDetailCalendarApi =(params={})=> {
    const url = MyDetailCalendarURL;
    return authAxios().get(url,{params});
}

export const GetListUserApi =(params={})=> {
    const url = listUserURL;
    return authAxios().get(url,{params});
}

export const GetListRoleApi =(params={})=> {
    const url = listRoleURL;
    return authAxios().get(url,{params});
}

export const GetListGroupRoleApi =(params={})=> {
    const url = listGroupRoleURL;
    return authAxios().get(url,{params});
}

export const GetUserEditApi =(params={})=> {
    const url = userEditURL;
    return authAxios().get(url(params));
}

export const GetPhuongThucCCApi =(params={})=> {
    const url = listPhuongThucCCURL;
    return authAxios().get(url,{params});
}

export const GetLoaiNVApi =(params={})=> {
    const url = listLoaiNVURL;
    return authAxios().get(url,{params});
}

export const GetLoaiUserApi =(params={})=> {
    const url = listLoaiUserURL;
    return authAxios().get(url,{params});
}

export const GetChucVuApi =(params={})=> {
    const url = listChucVuURL;
    return authAxios().get(url,{params});
}

export const PostUserApi = (params={})=>{
    const url = handUserURL;
    return authAxios().post(url,params);
}

export const PutUserApi = (params={})=>{
    const url = handUserURL;
    return authAxios().put(url,params);
}

export const PutRoleUserApi = (params={})=>{
    const url = updateRoleUserURL;
    return authAxios().put(url,params);
}

export const GetListTotalTimeApi =(params={})=> {
    const url = listTotalTimeURL;
    return authAxios().get(url,{params});
}

export const PutChangePassApi =(id, params={})=> {
    const url = userEditURL;
    return authAxios().put(url(id), params );
}


export const PutForgotPassApi =(id, params={})=> {
    const url = userEditURL;
    return authAxios().put(url(id), params );
}

export const ResetPassrApi = (params={})=>{
    const url = resetPassUrl;
    return authAxios().post(url,params);
}

export const CheckUserHomeApi = (params={})=>{
    const url = checkUserHomeUrl;
    return authAxios().post(url,params);
}
